module.exports = __webpack_public_path__ + "img/pc.ca5a083.png";